<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-14"></menubar>
    </div>
    <!--  左メニュー 終了 -->
      <!-- ヘッダー行 開始 -->
      <el-row slot="header">
        <head-title class="cancel-width">
          <label slot="title">{{ $t("title.system.area.title") }}</label>
          <sp-smart-button
            @click="backAreaSearch"
            slot="cancel">
            キャンセル
          </sp-smart-button>
          <narrow-down
            @click="createArea"
            slot="create">
            {{ $t("button.common.data.create") }}
          </narrow-down>
        </head-title>
      </el-row>
      <!-- ヘッダー行 終了 -->

      <!--  フォーム 開始  -->
    <div slot="body">
      <!-- subtitle -->
      <div class="main-title">
        {{ $t("title.system.area.create") }}
      </div>

      <el-row class="must-top m-bottom-5">
        <span class="must-color">* </span>
        <span class="text-main-size">{{ $t("label.common.must") }}</span>
      </el-row>

      <el-row class="must-top">
        <el-col>
          <el-form
            ref="ruleForm"
            label-width="200px"
            label-position="left"
            :rules="rules"
            :model="areaInfo">

            <!-- オーナーID -->
            <el-form-item
              size="small"
              class="new-input-style line-height-44"
              :label="$t('label.system.area.create.ownerExId')">
              <el-input
                maxlength="20"
                v-model="areaInfo.ownerExId"
                :readonly="true"
                :placeholder="$t('label.system.building.create.ownerIdPlaceholder')">
              </el-input>
            </el-form-item>

            <!-- オーナー名 -->
            <el-form-item
              size="small"
              prop="ownerName"
              class="master-start lable-margin-top-30 line-height-44"
              :label="$t('label.system.area.create.ownerName')"
            >
              <el-row>
                <el-col class="el-col-input-width">
                  <el-input
                    maxlength="50"
                    class="new-input-style"
                    :readonly="true"
                    v-model="areaInfo.ownerName"
                    :placeholder="'オーナー選択'">
                  </el-input>
                </el-col>
                <el-col class="el-col-select-button">
                  <select-btn @click="searchOwnerPopup">
                    {{$t("button.common.select")}}
                  </select-btn>
                </el-col>
              </el-row>
            </el-form-item>

            <!-- ビルID -->
            <el-form-item
              size="small"
              class="lable-margin-top-30 line-height-44"
              :label="$t('label.system.area.create.buildingExId')">
              <el-input
                maxlength="20"
                class="new-input-style"
                v-model="areaInfo.buildingExId"
                :readonly="true"
                :placeholder="$t('label.system.building.create.ownerIdPlaceholder')">
              </el-input>
            </el-form-item>

            <!-- ビル名 -->
            <el-form-item
              size="small"
              class="master-start lable-margin-top-30 line-height-44"
              prop="buildingName"
              :label="$t('label.system.area.create.buildingName')"
            >
              <el-row>
                <el-col class="el-col-input-width">
                  <el-input
                    maxlength="50"
                    class="new-input-style"
                    :readonly="true"
                    v-model="areaInfo.buildingName"
                    :placeholder="'ビル選択'">
                  </el-input>
                </el-col>
                <el-col class="el-col-select-button">
                  <select-btn @click="searchBuildingPopup">
                    {{$t("button.common.select")}}
                  </select-btn>
                </el-col>
              </el-row>
            </el-form-item>

            <!-- フロア -->
            <el-form-item
              size="small"
              prop="floorName"
              class="lable-margin-top-30 master-start line-height-44"
              :label="$t('label.system.area.create.floorName')"
            >
              <el-row>
                <el-col class="el-col-input-width">
                  <el-input
                    maxlength="50"
                    class="new-input-style"
                    :readonly="true"
                    v-model="areaInfo.floorName"
                    :placeholder="'フロア選択'">
                  </el-input>
                </el-col>
                <el-col class="el-col-select-button">
                  <select-btn @click="searchFloorPopup">
                    {{$t("button.common.select")}}
                  </select-btn>
                </el-col>
              </el-row>
            </el-form-item>

            <!-- エリア名 -->
            <el-form-item
              size="small"
              class="master-start lable-margin-top-30 area-name-input line-height-44"
              prop="areaName"
              :label="$t('label.system.area.create.areaName')"
            >
              <el-input
                type="text"
                maxlength="50"
                v-model="areaInfo.areaName"
                placeholder="エリア名"
                class="show-word-limt-input-iot"
                show-word-limit
              />
            </el-form-item>

            <!-- エリア区分 -->
            <el-form-item
              size="small"
              class="master-start lable-margin-top-30 area-type line-height-40"
              prop="areaType"
              :label="$t('label.system.area.create.areaType')"
            >
              <el-select
                v-model="areaInfo.areaType"
                :placeholder="$t('label.system.area.create.areaTypeSelect')"
              >
                <el-option
                  v-for="area in areaType"
                  :key="area.value"
                  :label="area.label"
                  :value="area.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              size="small"
              class="lable-margin-top-30 up-img"
              :label="$t('label.system.area.create.mapimage')">
              <upload-image-map
                @eventImage="changeMapImage($event)">
              </upload-image-map>
            </el-form-item>

            <el-form-item
              size="small"
              class="lable-margin-top-30 up-img"
              :label="$t('label.system.area.create.areaimage')">
              <upload-image
                @eventImage="changeImage($event)">
              </upload-image>
            </el-form-item>

            <el-form-item
              size="small"
              class="lable-margin-top-30 up-img-sp"
              :label="$t('label.system.area.create.areaSPimage')">
              <upload-image-s-p
                @eventImage="changeSPImage($event)">
              </upload-image-s-p>
            </el-form-item>
          </el-form>

          <narrow-down
            class="m-left-200 m-top-60"
            @click="createArea">
            {{ $t("button.common.data.create") }}
          </narrow-down>

        </el-col>

      </el-row>

      <!--  フォーム 終了  -->

      <!-- オーナー選択 -->
      <owner-search-popup
        :ownerExIdParam="areaInfo.ownerExId"
        :ownerNameParam="areaInfo.ownerName"
        :visible.sync="ownerSearchFlg"
        :includeDeleteDataFlag="false"
        @on-selected="getOwnerInfo"
      />

      <!-- ビル選択 -->
      <building-search-popup
        :ownerIdParam="areaInfo.ownerId"
        :buildingExIdParam="areaInfo.buildingExId"
        :buildingNameParam="areaInfo.buildingName"
        :visible.sync="buildingSearchFlg"
        :includeDeleteDataFlag="false"
        @on-selected="getBuildingInfo"
      />

      <!-- フロア選択 -->
      <floor-search-popup
        :ownerIdParam="areaInfo.ownerId"
        :buildingIdParam="areaInfo.buildingId"
        :floorNameParam="areaInfo.floorName"
        :visible.sync="floorSearchFlg"
        :includeDeleteDataFlag="false"
        @on-selected="getFloorInfo"
      />

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>
      <loading-dialog :dialogVisible="showLoading" />
    </div>
  </main-layout>
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import NewDesignLayout from "@/layout/NewDesignLayout"
import SystemManageApi from "@/api/SystemManageApi";
import OwnerSearchPopup from "@/components/system/popup/OwnerSearchPopup";
import BuildingSearchPopup from "@/components/system/popup/BuildingSearchPopup";
import FloorSearchPopup from "@/components/system/popup/FloorSearchPopup";
import AreaCreateRuleFactory from "@/rules/rule-area-create";
import UploadImage from "@/components/common/sp-smart-upload/index"
import UploadImageMap from "@/components/common/sp-smart-upload/indexMap"
import UploadImageSP from "@/components/common/sp-smart-upload/indexSP"
// ボタンコンポーネントの紹介
import Menubar from "@/components/leftmenu/DashBoard"
import SpSmartButton from "@/components/common/sp-smart-button"
import selectBtn from "@/components/common/generalButton/Select"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import headTitle from "@/components/common/head/head"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import elDialogPrompt from "@/components/common/el-dialog-prompt"

export default {
  name: "AreaCreate",
  components: {
    MainLayout: NewDesignLayout,
    OwnerSearchPopup: OwnerSearchPopup,
    BuildingSearchPopup: BuildingSearchPopup,
    narrowDown: narrowDown,
    selectBtn: selectBtn,
    LoadingDialog: LoadingDialog,
    Menubar: Menubar,
    UploadImage: UploadImage,
    UploadImageMap: UploadImageMap,
    SpSmartButton: SpSmartButton,
    FloorSearchPopup: FloorSearchPopup,
    headTitle: headTitle,
    UploadImageSP: UploadImageSP,
    elDialogPrompt
  },
  data() {
    return {
      msgParam: this.$t("message.common.validation.saveMessage",{
        field: "エリア"
      }),
      centerDialogVisibleIsShow: false,
      areaId: null,
      imgUrl: null,
      ownerSearchFlg: false,
      buildingSearchFlg: false,
      floorSearchFlg: false,
      showLoading: false,
      rules: AreaCreateRuleFactory.areaCreateRules(this),
      areaInfo: {
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorId: null,
        floorName: null,
        areaName: null,
        areaType: null,
        imgFile: null,
        imgSPFile: null
      },
      areaType: [
        {
          value: "01",
          label: this.$t("label.system.area.create.commonArea"),
        },
        {
          value: "02",
          label: this.$t("label.system.area.create.tenantLoan"),
        },
        {
          value: "03",
          label: this.$t("label.system.area.create.dayLoan"),
        },
        {
          value: "04",
          label: this.$t("label.system.area.create.other"),
        },
      ],
    };
  },
  created () {
    this.$authCheck("010502")
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/areas/search",
        title: "label.router.area",
      },
      {
        path: "",
        title: "label.router.areaCreate",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
  },
  methods: {
    /**
     * オーナー選択
     */
    searchOwnerPopup() {
      this.ownerSearchFlg = true;
    },

    /**
     * オーナー選択
     */
    getOwnerInfo(owner) {
      this.areaInfo.ownerId = owner.id;
      this.areaInfo.ownerExId = owner.exId;
      this.areaInfo.ownerName = owner.name;
      this.areaInfo.buildingId = null;
      this.areaInfo.buildingExId = null;
      this.areaInfo.buildingName = null;
      this.areaInfo.floorId = null;
      this.areaInfo.floorExId = null;
      this.areaInfo.floorName = null;
    },
    //获取图片Base64
    getImg(value) {
      this.imgUrl = value;
    },

    /**
     * ビル選択
     */
    searchBuildingPopup() {
      this.buildingSearchFlg = true;
    },

    /**
     * ビル選択
     */
    getBuildingInfo(building) {
      this.areaInfo.ownerId = building.ownerId;
      this.areaInfo.ownerExId = building.ownerExId;
      this.areaInfo.ownerName = building.ownerName;
      this.areaInfo.buildingId = building.buildingId;
      this.areaInfo.buildingExId = building.buildingExId;
      this.areaInfo.buildingName = building.buildingName;
      this.areaInfo.floorId = null;
      this.areaInfo.floorExId = null;
      this.areaInfo.floorName = null;
    },

    /**
     * フロア選択
     */
    searchFloorPopup() {
      this.floorSearchFlg = true;
    },

    /**
     * フロア選択
     */
    getFloorInfo(floor) {
      this.areaInfo.ownerId = floor.ownerId;
      this.areaInfo.ownerExId = floor.ownerExId;
      this.areaInfo.ownerName = floor.ownerName;
      this.areaInfo.buildingId = floor.buildingId;
      this.areaInfo.buildingExId = floor.buildingExId;
      this.areaInfo.buildingName = floor.buildingName;
      this.areaInfo.floorId = floor.floorId;
      this.areaInfo.floorExId = floor.floorExId;
      this.areaInfo.floorName = floor.floorName;
    },

    /**
     * 返回 エリア一覧
     */
    backAreaSearch() {
      this.$router.push({
        name: "system-area-search",
      });
    },

    /**
     * エリア新規登録
     */

    isPassParam(param){
      if(param){
        this.doneCreateArea();
      }
    },


    createArea() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.centerDialogVisibleIsShow = true
        }
      })
    },
        //画像アップロード
    changeMapImage(data) {
      this.areaInfo.imgMapFile = data
    },

    //画像アップロード
    changeImage(data) {
      for(var i = 0; i < data.length; i++){
        this.areaInfo.imgFile = data[i].raw
      }
    },

    //画像アップロード
    changeSPImage(data) {
      for(var i = 0; i < data.length; i++){
        this.areaInfo.imgSPFile = data[i].raw
      }
    },

    getImageFile(file) {
      this.areaInfo.imgFile = file;
      if (file) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imgUrl = reader.result;
        };
      } else {
        this.imgUrl = null;
      }
    },

    /**
     * エリア新規登録
     */
    doneCreateArea() {
      this.centerDialogVisibleIsShow = false;
      this.showLoading = true;
      SystemManageApi.createArea({
        buildingId: this.areaInfo.buildingId,
        floorId: this.areaInfo.floorId,
        // floorId: 2,
        areaName: this.areaInfo.areaName,
        areaType: this.areaInfo.areaType,
        portrait: this.areaInfo.imgFile,
        spPortrait: this.areaInfo.imgSPFile,
        mapPortrait: this.areaInfo.imgMapFile,
      })
      .catch((error) => {
          errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          return;
        }
        this.successMessage()
        this.areaId = data.body.areaId;
        this.$router.push({
          name: "system-area-detail",
          params: {
            areaId: this.areaId,
          },
        });
      }).finally(()=>{
        this.showLoading = false
      })
    },
    successMessage(){
      this.$messageIotSuccess(this.$t("message.common.createSuccess", {
        field: this.$t("message.common.validation.areaDesksMessage"),
      }))
    }
  },
};
</script>

<style lang="scss" scoped>
.margin-top-50 {
  margin-top: 50px;
}
::v-deep .back-img {
  img {
    width: 16px;
  }
}
::v-deep.el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before {
  content: "";
  display: none;
}
::v-deep.el-input--small {
  width: 200px;
}
::v-deep .el-input__inner {
  height: 26px;
  line-height: 32px;
  color: #2699fb;
  font-size: 12px;
  border-color: #BCE0FD;
  border-radius: 0px;
}
.width-200 {
  width: 200px;
  height: 26px;
}
::v-deep input::-webkit-input-placeholder {
  font-size: 14px;
}
::v-deep .margin-left-1 {
  .glance {
    width: 39px;
    height: 19px;
  }
}
::v-deep form {
  .el-form-item__label {
    font-size: 12px;
    padding-left: 0px !important;
  }
}
.line-height-36{
  line-height: 36px;
}
::v-deep label{
  padding-left: 15px !important;
}
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}

.must-top{
  color:#525250;
}

.lable-margin-top-30 {
  margin-top: 30px;
}

.must-color {
  color: #E65245;
}

.text-main-size {
  font-size: 16px;
  color: #525250 !important;
}

::v-deep form .el-form-item__label {
  font-size: 16px;
  padding-left: 0px !important;
  color: #525250 !important;
}

.master-start {
  width: 1000px;
}

::v-deep .master-start > .el-form-item__label::after{
  content: "*";
  color: #F56C6C;
  margin-right: 4px;
}

.el-col-input-width {
  width: 324px;
  margin-right: 16px;
}

.el-col-select-button {
  width: 200px;
}

::v-deep .area-name-input >.el-form-item__content>.el-input> .el-input__inner{
    width: 324px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #F2F2ED;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }

  .area-type {
  height: 40px;
  ::v-deep .el-select{
    line-height: 42px;
    width: 188px;
    height: 40px;
    background: #F2F2ED;
    border-radius: 8px;
    overflow: hidden;
    color: #fff;
    box-shadow: -2px -2px 5px #fff,
                  5px 5px 8px #E6E6E1;
    .el-input__inner{
      line-height: 24px;
      color: #525250;
      font-size: 15px !important;
      padding-left: 20px;
    }
    ::placeholder{
        color: #525250;
    }

  }

  ::v-deep .el-input__inner{
    border: none;
    background: #F2F2ED !important;
    color: #525250;
    font-size: 15px !important;
  }
  ::v-deep .el-icon-arrow-up:before {
    color: #525250;
  }
}
::v-deep .new-input-style {
  .el-input__inner{
    width: 324px;
    height: 44px !important;
    color: #525250;
    border-radius: 8px !important;
    background: #F2F2ED;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
    4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }
}

::v-deep .img-list .img-li-box .img-li-b--url {
  background-color: #F7F7F2;
  object-fit: scale-down;
  max-width: 550px;
  width: auto;
}

.img-list {
  ::v-deep .auth-image-box{
    .auth-image {
      object-fit: scale-down;
      background-color: #F7F7F2;
    }
  }
}

.line-height-44::v-deep {
  .el-form-item__label {
    line-height: 44px !important;
  }
}

.line-height-40::v-deep {
  .el-form-item__label {
    line-height: 40px !important;
  }
}

.up-img::v-deep {
  .img-list .border-style {
    margin-top: 0px;
  }
}

.up-img-sp::v-deep {
  .img-list .border-style {
    margin-top: 0px;
  }
}

.m-left-200 {
  margin-left: 200px;
}

.m-top-60 {
  margin-top: 60px;
}
</style>
